// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3l4Y_","colBig":"styles_colBig__3FL0c","colSmall":"styles_colSmall__1UlNg"};